<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-app>
        <v-navigation-drawer app v-model="isDrawerView" temporary>
            <v-list-item dense>
                <v-btn icon @click="isDrawerView = false"><v-icon>mdi-menu</v-icon></v-btn>
                <v-spacer />
                圃場管理
                <!-- <v-img src="@/assets/title.png" max-height="48" contain /> -->
            </v-list-item>
            <v-divider /> 
            <template v-for="menu in menuItems">
                <v-list v-if="menu.type == 'group' && ((isShareMode && menu.share) || (!isShareMode && menu.nonShare)) " :key="menu.id" nav dense>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>{{menu.title}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <template v-for="item in menu.items">
                        <v-list-item v-if="(isShareMode && item.share) || (!isShareMode && item.nonShare) " @click="onClickMenuItem(item)" :key="item.id" >
                            <v-list-item-icon>
                                <v-icon>{{item.icon}}</v-icon>
                            </v-list-item-icon>                    
                            <v-list-item-content>
                                <v-list-item-title>{{item.title}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                </v-list>
                <v-divider v-if="menu.type == 'separator'" :key="menu.id" />
            </template>
        </v-navigation-drawer>
        <v-app-bar app :color="isShareMode ? 'cyan darken-1' : 'primary'" dark flat :dense="$vuetify.breakpoint.xs">
            <v-app-bar-nav-icon v-if="loginState == 1" @click="isDrawerView = !isDrawerView" />
            <v-toolbar-title class="pl-0">
                <!-- My圃場 ～圃場作業記録～ <span class="body-2">Ver1.1.0</span> -->
                <table v-if="!$vuetify.breakpoint.xs"><tr>
                    <td><v-img src="@/assets/icon-72x72_no_bg.png" max-width="48" max-height="48" /></td>
                    <!-- <td>My圃場 ～圃場作業記録～ <span class="body-2">Ver2.3.1</span></td> -->
                    <td>圃場管理 <span class="body-2">Ver{{systemVersion}}</span></td>
                </tr></table>
                <!-- <span v-else class="body-2" style="margin-left:-20px">Ver2.5.9</span> -->
                <table v-else >
                    <tr class="body-1"><td>圃場管理</td></tr>
                    <tr class="caption"><td>Ver{{systemVersion}}</td></tr>
                </table>
            </v-toolbar-title>
            <v-spacer />
            <v-btn v-if="loginState == 1 && loggedInUserData != null" :color="isShareMode ? 'cyan darken-1' : 'primary'" elevation="0" @click="onClickLogout" class="pa-0">                
                <table><tr>
                    <td>
                        <v-avatar size="36" rounded>
                            <v-img v-if="loggedInUserData.avaterImage != null" :src="loggedInUserData.avaterImage.url" />
                            <v-img v-if="loggedInUserData.avaterImage == null" src="@/assets/no_avater_image.png"/>
                        </v-avatar>
                    </td>
                    <td v-if="!$vuetify.breakpoint.xs">{{loggedInUserData.userName}}</td>
                </tr></table>
            </v-btn>
            <!-- <v-btn v-if="loginState == 0 || loginState == 2" :color="isShareMode ? 'cyan darken-1' : 'primary'" elevation="0" @click="onClickLogout">
                <v-icon>mdi-login-variant</v-icon>ログイン
            </v-btn> -->
        </v-app-bar>

        <div style="height:100%">
            <!-- <v-content>
                <v-sheet v-if="isShareMode" outlined class="text-center ml-1 mr-1 mt-1 pa-1" color="cyan darken-1 white--text">現在、{{userData.user.userInfo.userName}} さんの圃場管理を表示中です。</v-sheet>
                <router-view />
                <v-btn @click="onClickReload" x-small elevation="0" color="transparent blue--text" class="ml-1 mt-3">reload</v-btn>
            </v-content> -->
            <v-main>
                <v-sheet v-if="isShareMode" outlined class="text-center ml-1 mr-1 mt-1 pa-1" color="cyan darken-1 white--text">現在、{{userData.user.userInfo.userName}} さんの圃場管理を表示中です。</v-sheet>
                <router-view />
                <!-- <v-btn @click="onClickReload" x-small elevation="0" color="transparent blue--text" class="ml-2 mt-2">reload</v-btn> -->
            </v-main>
        </div>

        <!-- スマホの時は、画面下のナビゲーションは表示せずに、代わりにホームに戻るフローティングボタンを表示する -->
        <v-fab-transition>
            <v-btn v-if="$vuetify.breakpoint.xs && mode!='title' && mode!=null" fixed fab bottom right color="#1976d2A0" style="right: 5px; bottom: 5px" @click="onClickHome()">
                <v-icon color="white">mdi-home</v-icon>
            </v-btn>
        </v-fab-transition>

        <!-- スマホ以外の時は、画面下にナビゲーションを表示 -->
        <v-bottom-navigation
            v-if="!$vuetify.breakpoint.xs"
            app
            color="primary">
            <v-app-bar>
                <div style="position:absolute; width:100%; text-align:center; margin-left:-16px">
                    <v-fab-transition>
                        <v-btn v-if="mode != 'title' && mode != null" @click="onClickHome()">
                            HOME
                            <v-icon large>mdi-home-circle-outline</v-icon>
                        </v-btn>
                    </v-fab-transition>
                </div>
                <v-spacer />
                <v-badge v-if="notOpenedNotificationNum > 0" color="green" :content="notOpenedNotificationNum+''" overlap class="mr-3" >
                    <v-icon @click="onClickNotificationIcon">
                        mdi-send
                    </v-icon>
                </v-badge>
                <Clock v-if="!$vuetify.breakpoint.xs" type="digital_mini" :isShowMilitaryTime="true" :isShowAmPm="false" color="grey" />
            </v-app-bar>
        </v-bottom-navigation> 

        <Processing />
        <Confirm ref="confirm" />
    </v-app>
</template>

<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }

    import db from '@/firebase/firestore.js'
    import fb from '@/firebase/firebase.js'
    import Processing from '@/components/tools/Processing';
    import Confirm from '@/components/tools/ConfirmDialog';
    import Clock from '@/components/tools/Clock';
    import Weather from '@/components/tools/WeatherViewer';
    export default {
        name: 'App',
        components: {
            Processing,
            Confirm,
            Clock,
            Weather,
        },
        data: function () {
            return {
                isDrawerView: false,
                menuItems: [
                    {
                        type: "group",
                        title: "管理",
                        share: true,
                        nonShare: true,
                        items: [
                            {
                                name: "place",
                                title: "圃場管理",
                                icon: "mdi-home-city",
                                share: true,
                                nonShare: true,
                            },
                            {
                                name: "seedling",
                                title: "苗管理",
                                icon: "mdi-sprout",                        
                                share: true,
                                nonShare: true,
                            },
                            // {
                            //     name: "observate_item",
                            //     title: "観察項目管理",
                            //     icon: "mdi-eye",
                            //     share: false,
                            //     nonShare: true,
                            // },
                            {
                                name: "notification",
                                title: "通知",
                                icon: "mdi-send",                        
                                share: false,
                                nonShare: true,
                            },
                            {
                                name: "group",
                                title: "グループ",
                                icon: "mdi-home-group",
                                share: false,
                                nonShare: true,
                            },
                        ]
                    },
                    // {
                    //     type: "separator",
                    // },
                    // {
                    //     type: "group",
                    //     title: "分析",
                    //     share: false,
                    //     nonShare: true,
                    //     items: [
                    //         {
                    //             name: "analys_agrichemical",
                    //             title: "農薬使用状況",
                    //             icon: "mdi-pill",                        
                    //             share: false,
                    //             nonShare: true,
                    //         },
                    //     ]
                    // },
                    {
                        type: "separator",
                    },
                    {
                        type: "group",
                        title: "その他",
                        share: false,
                        nonShare: true,
                        items: [
                            {
                                name: "setting",
                                title: "設定",
                                icon: "mdi-cog-outline",                        
                                share: false,
                                nonShare: true,
                            },
                            {
                                name: "version",
                                title: "バージョン情報",
                                icon: "mdi-message-alert",                        
                                share: false,
                                nonShare: true,
                            },
                        ]
                    },
                ]
            }
        },
        computed: { 
            systemVersion: function () {
                return this.$store.getters["systemVersion"]
            },
            cachedUsers: function () {
                return this.$store.getters["cachedUsers"]
            },
            loginState: function () {
                return this.$store.getters["loginState"]
            },
            shareMode: function () {
                return this.$store.getters["shareMode"]
            },
            shareModeTypes: function () {
                return this.$store.getters["shareModeTypes"]
            },
            enabledQRScan: function () {
                return this.$store.getters["enabledQRScan"]
            },
            loggedInUserData: function () {
                return this.$store.getters["loggedInUserData"]
            },
            loggedInUserLicense: function () {
                return this.$store.getters["loggedInUserLicense"]
            },
            userData: function () {
                console.log("App.userData", this.$store.getters["userData"])
                return this.$store.getters["userData"]
            },
            userName: function () {
                if (this.userData != null) {
                    return this.userData.userName
                }
                return ""
            },
            notOpenedNotificationNum: function () {
                const list = this.$store.getters["managementItems/notifications"].receiveList.list
                var num = 0
                for (var i=0; i<list.length; i++) {
                    if (list[i].body.openedDateTime == "") {
                        num++
                    }
                }
                return num
            },
            /** グループユーザーの圃場管理を参照中は True */
            isShareMode: function () {
                if (this.shareMode == this.shareModeTypes.groupUserWork) {
                    return true
                }
                return false
            },
            mode: function () {
                return this.$store.getters["homeMode"]
            }
        },
        created: function () {
            this.$store.commit("managementItems/setCallbacks", {
                userSetter: this.mi_userData,
                logger: this.mi_writeLog
            })
            // window.addEventListener("offline", ()=>{
            //     console.log("disconnect network")
            //     window.alert("ネットワークが切断されました。")
            // }, false)
            const self = this
            var lastDate = new Date()
            const connectionChecker = function () {
                if (self.loggedInUserData != null) {

                    const currentDate = new Date()
                    const interval = currentDate.getTime() - lastDate.getTime()

                    if ( interval > (1000 * 60) ) {
                        console.log("interval over ", interval)
                        self.mi_writeLog(
                            "App/created/connectionChecker", 
                            "チェック間隔の閾値超え(1分) > "+interval+"msec,last date="+lastDate.toFormatString("yyyy-MM-dd HH:mm:ss")+",current date="+currentDate.toFormatString("yyyy-MM-dd HH:mm:ss")+",home mode="+self.mode)
                        lastDate = currentDate
                    } else {
                        lastDate = currentDate
                    }

                    // db.collection("system").doc("system_state").get().then(function(){
                    //     setTimeout(connectionChecker, 60000)
                    // }).catch (function (error) {
                    //     self.$refs.confirm.show({
                    //         title: "データベース接続不可",
                    //         message: "データベースと接続が確認出来ませんでした。",
                    //         buttonYes: "ログアウト",
                    //         buttonNo: "再試行",
                    //         listenerYes: function () {
                    //             self.logout()
                    //             return true
                    //         },
                    //         listenerNo: function () {
                    //             setTimeout(connectionChecker, 1000)
                    //             return true
                    //         },
                    //     })
                    // })
                    setTimeout(connectionChecker, 1000)
                } else {
                    setTimeout(connectionChecker, 1000)
                }
            }
            setTimeout(connectionChecker, 1000)
            // this.$vuetify.theme.dark = true
            
            fb.auth().onAuthStateChanged(function(user){
                console.log("App/created/onAuthStateChanged", user, self.$store.getters["loginState"])
                if (user == null && self.$store.getters["loginState"] == 1) {
                    self.mi_writeLog("App/created/onAuthStateChanged", "ログアウト状態に遷移した(その操作を行っていない)")
                    self.$refs.confirm.show({
                        title: "続行不可",
                        message: "続行出来ません。<br/>ログアウトして、圃場管理システムを再起動します。",
                        buttonYes: "ログアウト",
                        buttonNo: "",
                        listenerYes: function () {
                            self.logout()
                            return true
                        },
                    })
                }
            })
        },
        beforeDestroy: function () {
            // if (this.$store.getters["userUID"] != "") {
            //     db.collection("users").doc(this.$store.getters["userUID"]).collection("notifications").onSnapshot(function(){
            //     },
            //     function (error){
            //         console.log("App", "beforeDestroy", error)
            //     })
            //     db.collection("users").doc(this.$store.getters["userUID"]).collection("sent_notifications").onSnapshot(function(){
            //     },
            //     function (error){
            //         console.log("App", "beforeDestroy", error)
            //     })
            // }
        },
        methods: {
            onClickNotificationIcon: function () {
                if (!this.isShareMode) {
                    this.$store.commit("homeMode", "notification_manage")
                } else {
                    this.$refs.confirm.show({
                        title: "通知管理不可",
                        message: "グループメンバーの圃場管理にいる時は、通知を表示出来ません。",
                        width: 450,
                        buttonYes: "戻る",
                        buttonNo: "",
                    })
                }
            },
            onClickMenuItem: function (item) {
                console.log("Menu item clicked", item.name)
                // if (this.shareMode != this.shareModeTypes.myWork) {
                //     console.log("current share mode is not my work. select cancel")
                //     this.$refs.confirm.show({
                //         title: "操作不可",
                //         message: "グループメンバー参照時は、メニューの項目は選択出来ません。<br/>あなたの管理を行う時は、HOMEボタンをクリックして<br/>ホーム画面に戻って下さい。",
                //         width: 550,
                //         buttonYes: "OK",
                //         buttonNo: "",
                //     })
                //     return
                // }
                this.isDrawerView = false
                this.$store.commit("selectedMenuItem", item.name)
            },
            onClickLogout: function () {
                console.log("onClickLogout ============================== ")
                const self = this
                this.logout()
            },
            onClickHome: function () {
                this.$store.commit("requestBackToHome", true)
            },
            onClickScanQRCode: function () {
                this.$store.commit("requestQRScan", true)
            },
            onClickReload: function () {
                console.log(this)
                window.location.reload()
            },
            /**
             * ログアウト処理
             */
            logout: function () {
                const self = this
                self.$store.commit("homeMode", "logout")
                self.mi_writeLog("App/logout", "logout")

                setTimeout(
                    function() {
                        fb.auth().signOut().then(function (){
                            console.log("firebase logout success")
                            self.$store.commit("userUID", "")
                            self.$store.commit("userData", null)
                            self.$store.commit("loginState", 2)
                            self.$store.commit("selectedMenuItem", "")
                            console.log("state cleared")
                            setTimeout(
                                function () {
                                    if (navigator.serviceWorker != null && navigator.serviceWorker.getRegistrations != null) {
                                        console.log("service worker delete start")
                                        navigator.serviceWorker.getRegistrations().then(function(registrations){
                                            try {
                                                for (const registration of registrations) {
                                                    registration.unregister()
                                                    console.log("service worker unregist!")
                                                }
                                            } catch (error) {
                                                console.log("service worker unregist failed!! => " + error)
                                            }
                                            console.log("page reload start")
                                            window.location.reload(true)
                                        })
                                    } else {
                                        console.log("page reload start")
                                        window.location.reload(true)
                                    }
                                },
                                1000
                            )
                        }).catch (function(error) {
                            console.log("logout failed!! reload start")
                            window.location.reload(true)
                        })
                    },
                    1000
                )
            }
        }
    }
</script>
<!--
<style lang="scss">
* :not(.v-icon) {
  font-family: "Meiryo UI","Meiryo UI", sans-serif!important;
}
</style>
-->

<style>
    html {
        touch-action: manipulation;
    }
</style>